import { ExpansionPanel } from '@abb-procure/common';
import { BooleanInput } from '@angular/cdk/coercion';
import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  input,
} from '@angular/core';
import { SearchBaseDto } from '../../types/search-base-dto.type';
import { SearchResultItemDto } from '../../types/search-result-item-dto.type';
import { SearchResultItem } from '../search-result-item/search-result-item.component';

@Component({
  selector: 'procure-search-result-list',
  templateUrl: './search-result-list.component.html',
  styleUrl: './search-result-list.component.scss',
  imports: [SearchResultItem, ExpansionPanel],
  host: {
    '[hidden]': '!values()?.length',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchResultList {
  readonly label = input.required<string | null>();
  readonly badge = input<number>();

  readonly values = input.required<
    SearchBaseDto[] | SearchResultItemDto[] | null
  >();

  readonly showDetail = input<boolean, BooleanInput>(true, {
    transform: booleanAttribute,
  });
}
